import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { closeConfirmToggle } from "../../store/reducers/schools/schools.reducer";
import { toggleSchoolActiveThunk, getSchoolsThunk } from "../../store/reducers/schools/schools.thunks";
import Loader from "../UI/Loader";
import Modal from "../UI/Modal";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleSchoolId, toggling, list, page, search } = useSelector(
    (state) => state.schools,
  );

  const school = list.find((s) => s.id === toggleSchoolId);

  const handleClose = () => {
    if (!toggling) {
      dispatch(closeConfirmToggle());
    }
  };

  const handleConfirm = async () => {
    const result = await dispatch(toggleSchoolActiveThunk(toggleSchoolId));
    if (result.meta.requestStatus === "fulfilled") {
      await dispatch(getSchoolsThunk({ page, search }));
      handleClose();
    }
  };

  if (!school) return null;

  return (
    <Modal
      open={confirmModalOpen}
      title={school.is_active ? "Desactivar Escuela" : "Activar Escuela"}
      size="md"
      onClose={handleClose}
    >
      <div className="text-center py-3">
        <Icon
          icon={school.is_active ? "mdi:alert-circle" : "mdi:check-circle"}
          width="64"
          height="64"
          className={`mb-3 ${school.is_active ? "text-warning" : "text-success"}`}
        />
        <h5 className="mb-3">
          {school.is_active
            ? "¿Estás seguro de desactivar esta escuela?"
            : "¿Estás seguro de activar esta escuela?"}
        </h5>
        <p className="text-muted mb-0">
          Escuela:{" "}
          <span className="fw-medium text-dark">{school.nombre}</span>
        </p>
        <p className="text-muted">
          Siglas: <code>{school.siglas}</code>
        </p>
      </div>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClose}
          disabled={toggling}
        >
          Cancelar
        </button>
        <button
          type="button"
          className={`btn ${school.is_active ? "btn-danger" : "btn-success"} d-flex align-items-center gap-2`}
          onClick={handleConfirm}
          disabled={toggling}
        >
          {toggling ? (
            <>
              <Loader type="spinner" size="sm" delay={0} />
              Procesando...
            </>
          ) : (
            <>
              <Icon
                icon={school.is_active ? "mdi:close-circle" : "mdi:check-circle"}
                width="20"
                height="20"
              />
              {school.is_active ? "Desactivar" : "Activar"}
            </>
          )}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmToggleModal;
